const storeLocationsSelect = () => {
	const select = document.querySelector('[data-store-locations-select]');
	if (!select) return;

	const idAsValue = select.dataset.idAsValue;
	const apiUrl = select.dataset.apiUrl || ncol_api_url;
	const apiEndpoint = `${apiUrl}/public/api/locations.json`;

	fetch(apiEndpoint)
		.then(response => response.json())
		.then(json => {
			if (json.status !== 'success') throw json;

			const stores = json.stores;

			// Sort by province_code, then name
			stores.sort((a, b) => {
				if (a.province_code < b.province_code) return -1;
				if (a.province_code > b.province_code) return 1;
				if (a.name < b.name) return -1;
				if (a.name > b.name) return 1;
				return 0;
			});

			stores.forEach(location => {
				const option = document.createElement('option');
				if (idAsValue) option.value = location.id;
				option.innerHTML = `${location.name} (${location.city}, ${location.province_code})`;
				select.appendChild(option);
			});
		})
		.catch(error => {
			console.error(error);
		});
};
(() => {
	storeLocationsSelect();
})();